import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ListApontamentosComponent } from './list-apontamentos/list-apontamentos.component';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { CancelarApontamentoComponent } from './cancelar-apontamento/cancelar-apontamento.component';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  declarations: [
    ListApontamentosComponent,
    CancelarApontamentoComponent
  ],
  imports: [
    SharedModule,
    CommonModule,
    MatIconModule,
  ],
  exports: [
    ListApontamentosComponent
  ],
})
export class ApontamentosModule {}